import {
	INPUT_MAX_LENGTH_INDICATOR_THRESHOLD,
	TEXTAREA_MAX_LENGTH_INDICATOR_THRESHOLD,
} from '../constants/input';

function showMaxLength(el) {
	return (
		el &&
		(el.tagName === 'TEXTAREA' || el.tagName === 'INPUT') &&
		el.getAttribute('maxlength')
	);
}

export default class Input {
	constructor(el, options = {}) {
		this.el = el;
		this.field = this.el.querySelector('input, textarea');
		if (!this.field) {
			return;
		}

		this.maxLengthIndicatorThreshold =
			options.maxLengthIndicatorThreshold ||
			INPUT_MAX_LENGTH_INDICATOR_THRESHOLD;
		this.focusedClassName = options.focusedClassName || 'input--is-focused';
		this.contentClassName = options.contentClassName || 'input--has-content';
		this.metaClassName = options.metaClassName || 'input__meta';
		this.metaOutsideClassName =
			options.metaOutsideClassName || 'input__meta--outside';
		this.noInlineLabelClassName =
			options.noInlineLabelClassName || 'input--no-inline-label';
		this.labelSelector = options.labelSelector || '.input__label';

		this.field.addEventListener('focus', this.handleFocus);
		this.field.addEventListener('blur', this.handleBlur);
		this.field.addEventListener('keyup', this.handleContentChange);
		this.field.addEventListener('keydown', this.handleContentChange);
		this.field.addEventListener('change', this.handleContentChange);
		this.field.addEventListener('blur', this.handleContentChange);

		this.showMaxLength = showMaxLength(this.field);

		if (this.showMaxLength) {
			this.lengthIndicator = document.createElement('span');
			this.lengthIndicator.className = this.metaClassName;

			if (this.field.tagName === 'INPUT') {
				this.lengthIndicator.className += ` ${this.metaOutsideClassName}`;
				this.maxLengthIndicatorThreshold = INPUT_MAX_LENGTH_INDICATOR_THRESHOLD;
			} else if (this.field.tagName === 'TEXTAREA') {
				this.maxLengthIndicatorThreshold =
					TEXTAREA_MAX_LENGTH_INDICATOR_THRESHOLD;
			}

			this.el.appendChild(this.lengthIndicator);
			this.updateMaxLength();
		}

		const hasLabel = this.el.querySelector(this.labelSelector);
		if (!hasLabel) {
			console.log(this.labelSelector);
			this.field.classList.add(this.noInlineLabelClassName);
		}

		this.handleContentChange();
	}

	handleFocus = () => {
		this.el.classList.add(this.focusedClassName);
	};

	handleBlur = () => {
		this.el.classList.remove(this.focusedClassName);
	};

	handleContentChange = () => {
		const hasContent = this.field.value.length > 0;

		if (hasContent || this.field.validity.badInput) {
			this.el.classList.add(this.contentClassName);
		} else {
			this.el.classList.remove(this.contentClassName);
		}

		if (this.showMaxLength) {
			this.updateMaxLength();
		}
	};

	updateMaxLength = () => {
		const length = this.field.value.length || 0;
		const maxlength = this.field.getAttribute('maxlength');
		this.lengthIndicator.textContent = `${length} av max ${maxlength} tecken`;
		this.lengthIndicator.classList.toggle(
			'is-hidden',
			length <= maxlength * this.maxLengthIndicatorThreshold
		);
	};
}
